export default __webpack_public_path__ + "static/media/IsreilyCruz1.88a7d639.png";